// extracted by mini-css-extract-plugin
export var boldText = "_7g-4";
export var checkboxContainer = "_7g-6";
export var closeIcon = "_7g-i";
export var container = "_7g-0";
export var drawer = "_7g-8";
export var drawerContent = "_7g-9";
export var extraSmallText = "_7g-5";
export var fulfillmentGroupTable = "_7g-e";
export var largeText = "_7g-3";
export var loadingSpinnerContainer = "_7g-j";
export var mediumText = "_7g-2";
export var narrow = "_7g-f";
export var notificationLink = "_7g-l";
export var packageCheckIconContainer = "_7g-7";
export var slideoutHeaderActions = "_7g-g";
export var slideoutHeaderActionsShifted = "_7g-h";
export var slideoutHeaderContainer = "_7g-a";
export var slideoutModal = "_7g-c";
export var stickyHeaderWrapper = "_7g-b";
export var table = "_7g-k";
export var tableContainer = "_7g-d";
export var tertiaryText = "_7g-1";